import { Controller } from '@stimulus/core'

export default class CheckDuplicateTitleController extends Controller {
    static targets = ["titleField"]

    connect() {
        const locale = 'nl';
        const urlInput = document.getElementById(`url_for_title_${locale}`) as HTMLInputElement | null;
        const url = urlInput?.value;
        const dutchTitleField = document.querySelector<HTMLInputElement>('input[id*="permanent_offer_title_nl"]');
    
        if (dutchTitleField && url) {
            dutchTitleField.dataset.url = url;

            if (dutchTitleField.value.trim() !== '') {
                this.submitCheckDuplicateTitle();
            }
    
            dutchTitleField.addEventListener('blur', () => {
                this.submitCheckDuplicateTitle();
            });
    
            this.element.addEventListener('title:selected', () => {
                this.submitCheckDuplicateTitle();
            });
        }
    }

    submitCheckDuplicateTitle() {
        const dutchTitleField = document.querySelector<HTMLInputElement>('input[id*="permanent_offer_title_nl"]');
        const titleText = dutchTitleField?.value.trim();
        const url = dutchTitleField?.dataset.url;
        const csrfToken = this.getCSRFToken();

        if (!url || !titleText) return;

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify({ title_text: titleText }),
        })
            .then(response => {
                if (!response.ok) throw new Error('Netwerkfout');
                return response.json();
            })
            .then(data => {
                this.showCheckResult(data.valid);
            })
            .catch(error => {
                console.error('Fout bij check duplicate titels:', error);
                this.showCheckResult(false, true);
            });
    }

    getCSRFToken(): string {
        const meta = document.querySelector('meta[name="csrf-token"]')
        return meta?.getAttribute('content') ?? ''
    }

    showCheckResult(valid: boolean, error = false) {
        const resultContainer = document.querySelector('#titel-check-result')
        if (!resultContainer) return

        if (error) {
            resultContainer.innerHTML = `<p class="text-danger mt-2">Er is een fout opgetreden bij het controleren.</p>`
        } else if (valid) {
            resultContainer.innerHTML = ''
        } else {
            resultContainer.innerHTML = `<p class="text-danger mt-2">Titel is al een keer eerder gebruikt</p>`
        }
    }
}
